export const environment = {
    appInsights: {instrumentationKey: '199b4db6-200f-4122-a17d-d43b7d82e8fe'},
    sessionTimeout: -1,
    clientId: '',
    appConfig: {
        apiBaseUrl: 'https://api-test.logassistance.org',
        authorityUrl: '',
        addressLookupUrl: '',
        addressLookupKey: '',
        disableApplicationsFeature: false,
        UWSTLAgencyId: "0a14e58f-691f-4093-acf5-42c50685de3a",
    },
    features: [],
    production: false
};
